export default __webpack_public_path__ + "static/media/monitor.a528a908.svg";